import {AutoSuggestVariables, SearchObjectsModel, SearchQuery} from "../../../../../types/Search";
import VariableOptions from "gql-query-builder/build/VariableOptions";
import {AutoSuggestQueryArgumentBuilder} from "./autosuggest-query-argument-builder";
import {QueryBuilder} from "../../query-builder";
import {gql} from "apollo-boost";
import {SIZE, TERMS} from "../variables";

export const OPERATION_NAME = 'AutoSuggest';
export const DEFAULT_SUGGEST_SIZE = 5;
export const DEFAULT_SUGGEST_FIELDS = ['id', 'name'];

export class AutoSuggestQueryBuilder {

  private readonly terms: string;
  private readonly searchObjectModel: SearchObjectsModel;

  constructor(terms: string, searchObjectModel: SearchObjectsModel) {
    this.terms = terms;
    this.searchObjectModel = searchObjectModel;
  }

  build(): SearchQuery {
    const suggestArguments = new AutoSuggestQueryArgumentBuilder(this.searchObjectModel).build();
    const queryOptions = QueryBuilder.buildQueryOptions({
      params: suggestArguments,
      fields: DEFAULT_SUGGEST_FIELDS,
      operationName: OPERATION_NAME,
      variables: AutoSuggestQueryBuilder.buildVariableOptions()
    });
    return {
      query: gql`${queryOptions.query}`,
      variables: AutoSuggestQueryBuilder.buildVariables(this.terms, DEFAULT_SUGGEST_SIZE)
    }
  }

  private static buildVariableOptions(): VariableOptions {
    const variables: VariableOptions = {};
    variables[TERMS] = {required: true, type: 'String'};
    variables[SIZE] = {required: true, type: 'Int'};
    return variables;
  }

  private static buildVariables(terms: string, size: number): AutoSuggestVariables {
    return {
      terms,
      size
    };
  }
}
